import { ApiError } from 'types/api.types';

export const DRIVER_NOT_ENABLED_MESSAGE =
  'You are not enabled as a driver for this organization. Ask an admin to enable your driver profile.';

export function formatDriverApiError(err: unknown, fallback: string): string {
  const apiErr = err instanceof ApiError ? err : (err as ApiError);
  const message = apiErr.message ?? fallback;
  if (
    apiErr.status === 403 &&
    message.toLowerCase().includes('not enabled as a driver')
  ) {
    return DRIVER_NOT_ENABLED_MESSAGE;
  }
  return message || fallback;
}
